import { useRouter } from 'vue-router';
import type { RouteLocationRaw } from 'vue-router';
import type { RouteKey } from '@elegant-router/types';

/**
 * 路由推送Hook
 *
 * @param allowLoginDelay 是否允许登录延迟
 */
export function useRouterPush(allowLoginDelay = true) {
  const router = useRouter();

  /**
   * 路由推送
   *
   * @param to 路由
   */
  async function routerPush(to: RouteLocationRaw) {
    await router.push(to);
  }

  /**
   * 路由替换
   *
   * @param to 路由
   */
  async function routerReplace(to: RouteLocationRaw) {
    await router.replace(to);
  }

  /**
   * 前往登录页面
   *
   * @param redirectUrl 重定向的url
   */
  async function toLogin(redirectUrl?: string) {
    const login = 'login';
    const route = redirectUrl ? { path: '/login', query: { redirectUrl } } : { path: '/login' };
    await routerPush(route);
  }

  /**
   * 登录后重定向
   *
   * @param redirect 是否重定向
   */
  async function redirectFromLogin(redirect: boolean) {
    const route = router.currentRoute.value;
    const { redirectUrl } = route.query;
    
    // 有重定向的url，就重定向到该url
    if (redirect && redirectUrl && typeof redirectUrl === 'string') {
      await routerPush(redirectUrl);
      return;
    }
    
    // 没有重定向的url，就重定向到首页
    await routerPush('/');
  }

  /**
   * 前往指定路由
   *
   * @param routeName 路由名称
   * @param options 路由参数
   */
  async function toRouteByName(routeName: RouteKey, options?: any) {
    await routerPush({ name: routeName, ...options });
  }

  return {
    routerPush,
    routerReplace,
    toLogin,
    redirectFromLogin,
    toRouteByName
  };
} 